export default __webpack_public_path__ + "06fd43104eb1c3c227f11a32ec7fad65.webp";